import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const LongFormSavedTemplate = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_6543_22076)">
          <rect
            y="0.199219"
            width="248"
            height="143"
            rx="8"
            fill="#DDEBDB"
          />
          <path
            d="M186.052 66.1523V141.667C186.052 143.375 185.374 145.013 184.166 146.22C182.959 147.428 181.321 148.106 179.613 148.106H68.4393C66.7315 148.106 65.0936 147.428 63.886 146.22C62.6784 145.013 62 143.375 62 141.667V66.1523H186.052Z"
            fill="white"
          />
          <path
            d="M185.909 66.155H61.8564V56.496C61.8564 54.7882 62.5349 53.1503 63.7425 51.9427C64.9501 50.7351 66.588 50.0566 68.2958 50.0566H179.469C181.177 50.0566 182.815 50.7351 184.023 51.9427C185.23 53.1503 185.909 54.7882 185.909 56.496V66.155Z"
            fill="white"
          />
          <path
            d="M185.909 135.199V56.496C185.909 54.7882 185.23 53.1503 184.023 51.9427C182.815 50.7351 181.177 50.0566 179.469 50.0566H163.5H68.2958C66.588 50.0566 64.9501 50.7351 63.7425 51.9427C62.5349 53.1503 61.8564 54.7882 61.8564 56.496V141.67C61.8564 143.378 62.5349 145.015 63.7425 146.223C64.9501 147.431 66.588 148.109 68.2958 148.109H179.469C181.177 148.109 182.815 147.431 184.023 146.223C185.23 145.015 185.909 143.378 185.909 141.67V128.199"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.8564 66.1523H185.5"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.1252 58.9087C73.9118 58.9087 73.707 58.8239 73.5561 58.6729C73.4051 58.522 73.3203 58.3172 73.3203 58.1037C73.3203 57.8903 73.4051 57.6855 73.5561 57.5346C73.707 57.3836 73.9118 57.2988 74.1252 57.2988"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M74.125 58.9087C74.3385 58.9087 74.5432 58.8239 74.6942 58.6729C74.8451 58.522 74.9299 58.3172 74.9299 58.1037C74.9299 57.8903 74.8451 57.6855 74.6942 57.5346C74.5432 57.3836 74.3385 57.2988 74.125 57.2988"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M157.147 76.3447H89.6323C89.2053 76.3447 88.7959 76.5143 88.494 76.8162C88.1921 77.1181 88.0225 77.5276 88.0225 77.9546V95.3939C88.0225 95.8209 88.1921 96.2303 88.494 96.5322C88.7959 96.8341 89.2053 97.0037 89.6323 97.0037H157.147C157.574 97.0037 157.983 96.8341 158.285 96.5322C158.587 96.2303 158.757 95.8209 158.757 95.3939V77.9546C158.757 77.5276 158.587 77.1181 158.285 76.8162C157.983 76.5143 157.574 76.3447 157.147 76.3447Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.4053 85.0542H96.4512L97.7256 88.5566L99.0044 85.0542H100.046L98.1475 90.1738H97.3081L95.4053 85.0542ZM94.7812 85.0542H95.8491L96.0513 89.0664V90.1738H94.7812V85.0542ZM99.6064 85.0542H100.683V90.1738H99.4087V89.0664L99.6064 85.0542ZM103.28 87.8184L104.607 85.0542H105.979L104.102 88.5039H103.417L103.28 87.8184ZM102.494 85.0542L103.83 87.8447L103.676 88.5039H102.999L101.118 85.0542H102.494ZM104.168 87.7656V90.1738H102.898V87.7656H104.168ZM111.27 85.0542V90.1738H109.995V85.0542H111.27ZM112.935 85.0542V86.0474H108.365V85.0542H112.935ZM117.29 89.1851V90.1738H114.346V89.1851H117.29ZM114.794 85.0542V90.1738H113.528V85.0542H114.794ZM116.912 87.0317V88.0205H114.346V87.0317H116.912ZM117.294 85.0542V86.0474H114.346V85.0542H117.294ZM118.485 85.0542H119.531L120.806 88.5566L122.084 85.0542H123.126L121.228 90.1738H120.388L118.485 85.0542ZM117.861 85.0542H118.929L119.131 89.0664V90.1738H117.861V85.0542ZM122.687 85.0542H123.763V90.1738H122.489V89.0664L122.687 85.0542ZM126.822 88.4644H125.442V87.4756H126.822C127.015 87.4756 127.175 87.4478 127.301 87.3921C127.427 87.3335 127.519 87.2559 127.578 87.1592C127.639 87.0596 127.67 86.9468 127.67 86.8208C127.67 86.6831 127.639 86.5557 127.578 86.4385C127.519 86.3213 127.427 86.2275 127.301 86.1572C127.175 86.084 127.015 86.0474 126.822 86.0474H125.912V90.1738H124.646V85.0542H126.822C127.261 85.0542 127.638 85.1304 127.951 85.2827C128.268 85.4351 128.509 85.6431 128.676 85.9067C128.846 86.1704 128.931 86.4722 128.931 86.812C128.931 87.0581 128.883 87.2837 128.786 87.4888C128.692 87.6909 128.553 87.8652 128.369 88.0117C128.187 88.1582 127.966 88.271 127.705 88.3501C127.447 88.4263 127.153 88.4644 126.822 88.4644ZM133.277 89.1851V90.1738H130.491V89.1851H133.277ZM130.939 85.0542V90.1738H129.674V85.0542H130.939ZM136.059 86.3857L134.697 90.1738H133.418L135.439 85.0542H136.31L136.059 86.3857ZM137.404 90.1738L136.015 86.3857L135.76 85.0542H136.644L138.678 90.1738H137.404ZM137.377 88.271V89.1719H134.547V88.271H137.377ZM141.451 85.0542V90.1738H140.177V85.0542H141.451ZM143.117 85.0542V86.0474H138.546V85.0542H143.117ZM147.472 89.1851V90.1738H144.527V89.1851H147.472ZM144.976 85.0542V90.1738H143.71V85.0542H144.976ZM147.094 87.0317V88.0205H144.527V87.0317H147.094ZM147.476 85.0542V86.0474H144.527V85.0542H147.476ZM150.899 88.8027C150.899 88.7207 150.883 88.646 150.851 88.5786C150.819 88.5083 150.765 88.4453 150.688 88.3896C150.615 88.334 150.516 88.2812 150.39 88.2314C150.264 88.1816 150.107 88.1348 149.919 88.0908C149.597 88.0146 149.317 87.9312 149.08 87.8403C148.846 87.7466 148.651 87.6396 148.496 87.5195C148.343 87.3965 148.229 87.25 148.153 87.0801C148.077 86.9102 148.039 86.7109 148.039 86.4824C148.039 86.2627 148.087 86.0605 148.184 85.876C148.28 85.6914 148.417 85.5332 148.592 85.4014C148.768 85.2695 148.976 85.167 149.216 85.0938C149.457 85.0205 149.719 84.9839 150.003 84.9839C150.416 84.9839 150.781 85.0483 151.097 85.1772C151.417 85.3062 151.666 85.4893 151.844 85.7266C152.023 85.9609 152.112 86.2437 152.112 86.5747H150.847C150.847 86.4517 150.813 86.3389 150.746 86.2363C150.681 86.1338 150.587 86.0518 150.464 85.9902C150.341 85.9258 150.189 85.8936 150.007 85.8936C149.832 85.8936 149.687 85.9214 149.572 85.9771C149.458 86.0298 149.373 86.0986 149.317 86.1836C149.265 86.2656 149.238 86.3506 149.238 86.4385C149.238 86.5117 149.254 86.5791 149.287 86.6406C149.322 86.7021 149.376 86.7593 149.449 86.812C149.525 86.8618 149.624 86.9102 149.744 86.957C149.867 87.001 150.015 87.0449 150.188 87.0889C150.51 87.1592 150.79 87.2427 151.027 87.3394C151.267 87.4331 151.466 87.5459 151.625 87.6777C151.786 87.8096 151.906 87.9663 151.985 88.1479C152.064 88.3267 152.104 88.5332 152.104 88.7676C152.104 89.002 152.055 89.2114 151.958 89.396C151.865 89.5776 151.729 89.7314 151.55 89.8574C151.374 89.9834 151.162 90.0801 150.913 90.1475C150.667 90.2119 150.391 90.2441 150.086 90.2441C149.814 90.2441 149.546 90.2119 149.282 90.1475C149.019 90.083 148.78 89.9834 148.566 89.8486C148.352 89.7109 148.181 89.5352 148.052 89.3213C147.926 89.1074 147.863 88.8511 147.863 88.5522H149.133C149.133 88.6929 149.153 88.813 149.194 88.9126C149.238 89.0122 149.303 89.0942 149.388 89.1587C149.476 89.2202 149.583 89.2656 149.708 89.2949C149.837 89.3242 149.985 89.3389 150.152 89.3389C150.34 89.3389 150.488 89.3125 150.596 89.2598C150.708 89.2041 150.785 89.1353 150.829 89.0532C150.876 88.9712 150.899 88.8877 150.899 88.8027Z"
            fill="#1E1E1E"
          />
          <path
            d="M89.0225 103.149H154.022"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.0225 109.149H146.022"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.0225 115.149H127.022"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.818 124.149H89.1857C88.8772 124.149 88.5813 124.272 88.3632 124.49C88.145 124.708 88.0225 125.004 88.0225 125.313V134.619C88.0225 134.927 88.145 135.223 88.3632 135.441C88.5813 135.659 88.8772 135.782 89.1857 135.782H100.818C101.127 135.782 101.422 135.659 101.641 135.441C101.859 135.223 101.981 134.927 101.981 134.619V125.313C101.981 125.004 101.859 124.708 101.641 124.49C101.422 124.272 101.127 124.149 100.818 124.149Z"
            fill="#ECF4EB"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.981 126.466H153.981"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.981 133.466H143.981"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.7839 58.9087C83.5704 58.9087 83.3657 58.8239 83.2148 58.6729C83.0638 58.522 82.979 58.3172 82.979 58.1037C82.979 57.8903 83.0638 57.6855 83.2148 57.5346C83.3657 57.3836 83.5704 57.2988 83.7839 57.2988"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M83.7837 58.9087C83.9972 58.9087 84.2019 58.8239 84.3529 58.6729C84.5038 58.522 84.5886 58.3172 84.5886 58.1037C84.5886 57.8903 84.5038 57.6855 84.3529 57.5346C84.2019 57.3836 83.9972 57.2988 83.7837 57.2988"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M93.4431 58.9106C93.2296 58.9106 93.0249 58.8258 92.8739 58.6749C92.723 58.5239 92.6382 58.3192 92.6382 58.1057C92.6382 57.8922 92.723 57.6875 92.8739 57.5365C93.0249 57.3856 93.2296 57.3008 93.4431 57.3008"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M93.4429 58.9106C93.6563 58.9106 93.8611 58.8258 94.012 58.6749C94.163 58.5239 94.2478 58.3192 94.2478 58.1057C94.2478 57.8922 94.163 57.6875 94.012 57.5365C93.8611 57.3856 93.6563 57.3008 93.4429 57.3008"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <rect
            x="158.053"
            y="30.1992"
            width="46"
            height="46"
            rx="23"
            fill="#F8FBF6"
          />
          <rect
            x="158.053"
            y="30.1992"
            width="46"
            height="46"
            rx="23"
            stroke="#1E1E1E"
            strokeWidth="2"
          />
          <path
            d="M188.705 66.4697L181.053 61.1131L173.4 66.4697C173.264 66.5649 173.105 66.621 172.939 66.6318C172.773 66.6427 172.608 66.6079 172.46 66.5312C172.313 66.4546 172.19 66.339 172.104 66.1971C172.017 66.0551 171.972 65.8923 171.972 65.7262V42.0428C171.972 41.5611 172.163 41.0991 172.504 40.7585C172.844 40.4179 173.306 40.2266 173.788 40.2266H188.318C188.799 40.2266 189.261 40.4179 189.602 40.7585C189.942 41.0991 190.134 41.5611 190.134 42.0428V65.7262C190.134 65.8923 190.088 66.0551 190.002 66.1971C189.916 66.339 189.792 66.4546 189.645 66.5312C189.497 66.6079 189.332 66.6427 189.166 66.6318C189.001 66.621 188.841 66.5649 188.705 66.4697Z"
            fill="#FFEF5E"
            stroke="#1E1E1E"
            strokeWidth="1.2973"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M199.388 94.3672L201.213 88.3904L207.188 90.2223"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M201.584 88.2336C208.097 95.4854 207.797 104.01 197.495 107.586"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.7875 20.6052L41.7682 26.7079L47.7417 25.1589C48.0404 25.0692 48.3604 25.071 48.6581 25.164C48.9558 25.2571 49.2165 25.4369 49.4047 25.6789C49.5929 25.9209 49.6994 26.2132 49.7096 26.516C49.7198 26.8187 49.6332 27.1171 49.4617 27.3703L45.5135 33.191L50.1592 38.8483C50.3663 39.1084 50.4841 39.4249 50.4959 39.7531C50.5077 40.0814 50.4129 40.4049 50.2249 40.6782C50.0369 40.9515 49.7651 41.1607 49.4478 41.2766C49.1305 41.3924 48.7836 41.4089 48.456 41.3238L40.4756 39.3316L34.5844 44.9312C34.3447 45.1634 34.0357 45.3169 33.7011 45.3701C33.3665 45.4233 33.023 45.3736 32.719 45.2279C32.415 45.0822 32.1657 44.8479 32.0063 44.5579C31.8469 44.2679 31.7854 43.9369 31.8304 43.6114L32.9221 36.456L26.4955 33.3255C26.2148 33.1911 25.984 32.9757 25.8349 32.709C25.6858 32.4423 25.6257 32.1375 25.6628 31.8364C25.7 31.5353 25.8327 31.2529 26.0425 31.0279C26.2523 30.803 26.529 30.6466 26.8345 30.5803L32.82 29.0282L33.9843 21.332C34.0528 21.0507 34.1988 20.7926 34.4066 20.5852C34.6144 20.3778 34.8764 20.2289 35.1647 20.1541C35.453 20.0793 35.7568 20.0816 36.044 20.1607C36.3311 20.2397 36.5908 20.3926 36.7955 20.6031L36.7875 20.6052Z"
            fill="#FFEF5E"
          />
          <path
            d="M41.7673 26.7057L36.7865 20.603C36.5819 20.3925 36.3222 20.2396 36.035 20.1605C35.7479 20.0815 35.444 20.0792 35.1557 20.154C34.8674 20.2287 34.6055 20.3777 34.3976 20.5851C34.1898 20.7925 34.0439 21.0506 33.9754 21.3319L32.811 29.0281L26.8256 30.5801C26.5217 30.6484 26.247 30.8057 26.0388 31.0307C25.8306 31.2556 25.699 31.5372 25.6619 31.8372C25.6249 32.1372 25.6842 32.441 25.8317 32.7073C25.9793 32.9736 26.2079 33.1894 26.4866 33.3254L32.9132 36.4559L31.8273 43.6014C31.78 43.9807 31.8784 44.3636 32.1038 44.6772L43.0043 26.3849L41.7673 26.7057Z"
            fill="#FFF9BF"
          />
          <path
            d="M36.7875 20.6052L41.7682 26.7079L47.7417 25.1589C48.0404 25.0692 48.3604 25.071 48.6581 25.164C48.9558 25.2571 49.2165 25.4369 49.4047 25.6789C49.5929 25.9209 49.6994 26.2132 49.7096 26.516C49.7198 26.8187 49.6332 27.1171 49.4617 27.3703L45.5135 33.191L50.1592 38.8483C50.3663 39.1084 50.4841 39.4249 50.4959 39.7531C50.5077 40.0814 50.4129 40.4049 50.2249 40.6782C50.0369 40.9515 49.7651 41.1607 49.4478 41.2766C49.1305 41.3924 48.7836 41.4089 48.456 41.3238L40.4756 39.3316L34.5844 44.9312C34.3447 45.1634 34.0357 45.3169 33.7011 45.3701C33.3665 45.4233 33.023 45.3736 32.719 45.2279C32.415 45.0822 32.1657 44.8479 32.0063 44.5579C31.8469 44.268 31.7854 43.9369 31.8304 43.6114L32.9221 36.456L26.4955 33.3255C26.2148 33.1911 25.984 32.9757 25.8349 32.709C25.6858 32.4423 25.6257 32.1375 25.6628 31.8364C25.7 31.5353 25.8327 31.2529 26.0425 31.0279C26.2523 30.803 26.529 30.6466 26.8345 30.5803L32.82 29.0282L33.9843 21.332C34.0528 21.0507 34.1988 20.7926 34.4066 20.5852C34.6144 20.3778 34.8764 20.2289 35.1647 20.1541C35.453 20.0793 35.7568 20.0816 36.044 20.1607C36.3311 20.2397 36.5908 20.3926 36.7955 20.6031L36.7875 20.6052Z"
            stroke="#1E1E1E"
            strokeWidth="1.85651"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_6543_22076">
            <rect
              y="0.199219"
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
LongFormSavedTemplate.displayName = 'LongFormSavedTemplate';
